"use strict";

var _toConsumableArray = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _toArray = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var query_1 = require("@eth-sdk/query");

var utils_1 = require("@eth-sdk/utils");

var Contract = /*#__PURE__*/function (_query_1$WithQuery) {
  _inherits(Contract, _query_1$WithQuery);

  var _super = _createSuper(Contract);

  function Contract(abiItems) {
    var _this;

    var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, Contract);

    _this = _super.call(this, query);
    _this.abiItems = abiItems;
    _this.hasEvents = false;
    _this.hasFallback = false;
    _this.address = address;
    _this.eventsMap = {
      names: new Map(),
      signatures: new Map()
    };
    _this.methodsMap = {
      names: new Map(),
      signatures: new Map()
    };

    var _iterator = _createForOfIteratorHelper(abiItems),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var abiItem = _step.value;
        var type = abiItem.type,
            constant = abiItem.constant,
            name = abiItem.name,
            inputs = abiItem.inputs,
            outputs = abiItem.outputs,
            payable = abiItem.payable;

        switch (type) {
          case 'event':
            {
              var signature = Contract.buildSignature(name, inputs);
              var mappedEvent = {
                name: name,
                signature: signature,
                inputs: {
                  indexed: inputs.filter(function (_ref) {
                    var indexed = _ref.indexed;
                    return indexed;
                  }),
                  nonIndexed: inputs.filter(function (_ref2) {
                    var indexed = _ref2.indexed;
                    return !indexed;
                  })
                }
              };
              _this.hasEvents = true;

              _this.eventsMap.names.set(name, mappedEvent);

              _this.eventsMap.signatures.set(signature, mappedEvent);

              break;
            }

          case 'function':
            {
              var _signature = Contract.buildSignature(name, inputs).slice(0, 10);

              var mappedMethod = {
                name: name,
                signature: _signature,
                outputs: outputs,
                inputs: inputs,
                constant: !!constant,
                payable: !!payable
              };

              _this.methodsMap.names.set(name, mappedMethod);

              _this.methodsMap.signatures.set(_signature, mappedMethod);

              break;
            }

          case 'fallback':
            {
              _this.hasFallback = true;
              break;
            }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _this.allEvents = _this.buildEvent();
    _this.events = _this.buildEvents();
    _this.methods = _this.buildMethods();
    return _this;
  }

  _createClass(Contract, [{
    key: "at",
    value: function at(address) {
      return new Contract(this.abiItems, address, this.query);
    }
  }, {
    key: "getAddress",
    value: function getAddress() {
      var optional = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var result = this.address || optional;

      if (!utils_1.isAddress(result)) {
        throw new Error('invalid contract address');
      }

      return result;
    }
  }, {
    key: "buildEvents",
    value: function buildEvents() {
      var result = {};
      var mappedEvents = this.eventsMap.names.values();

      var _iterator2 = _createForOfIteratorHelper(mappedEvents),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var mappedEvent = _step2.value;
          var name = mappedEvent.name,
              signature = mappedEvent.signature;
          result[name] = Object.assign({
            signature: signature
          }, this.buildEvent(signature));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return result;
    }
  }, {
    key: "buildMethods",
    value: function buildMethods() {
      var _this2 = this;

      var result = {};
      var mappedMethods = this.methodsMap.names.values();

      var _iterator3 = _createForOfIteratorHelper(mappedMethods),
          _step3;

      try {
        var _loop = function _loop() {
          var mappedMethod = _step3.value;
          var name = mappedMethod.name,
              signature = mappedMethod.signature,
              inputs = mappedMethod.inputs,
              constant = mappedMethod.constant,
              outputs = mappedMethod.outputs;

          var method = function method() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var data = utils_1.concatHex(signature, utils_1.abi.encode(inputs, args));
            return {
              data: data,
              call: function call() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var to, output;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (constant) {
                            _context.next = 2;
                            break;
                          }

                          throw new Error('call unsupported');

                        case 2:
                          to = options.to;
                          _context.next = 5;
                          return this.query.eth.call({
                            data: data,
                            to: this.getAddress(to)
                          });

                        case 5:
                          output = _context.sent;
                          return _context.abrupt("return", utils_1.abi.decode(outputs, output));

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));
              },
              estimate: function estimate() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var to, from, gasPrice, gas, value;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!constant) {
                            _context2.next = 2;
                            break;
                          }

                          throw new Error('estimate unsupported');

                        case 2:
                          to = options.to, from = options.from, gasPrice = options.gasPrice, gas = options.gas, value = options.value;
                          return _context2.abrupt("return", this.query.eth.estimateGas({
                            from: from,
                            gas: gas,
                            gasPrice: gasPrice,
                            value: value,
                            data: data,
                            to: this.getAddress(to)
                          }));

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
              },
              send: function send() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var to, from, gasPrice, gas, nonce, value;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!constant) {
                            _context3.next = 2;
                            break;
                          }

                          throw new Error('send unsupported');

                        case 2:
                          to = options.to, from = options.from, gasPrice = options.gasPrice, gas = options.gas, nonce = options.nonce, value = options.value;
                          return _context3.abrupt("return", this.query.eth.sendTransaction({
                            from: from,
                            gas: gas,
                            gasPrice: gasPrice,
                            nonce: nonce,
                            value: value,
                            data: data,
                            to: this.getAddress(to)
                          }));

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                }));
              }
            };
          };

          method.signature = signature;
          result[name] = method;
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return result;
    }
  }, {
    key: "buildEvent",
    value: function buildEvent() {
      var _this3 = this;

      var topic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var topics = topic ? [topic] : [];
      return {
        getLogs: function getLogs() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            var _this4 = this;

            var logs;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return this.query.eth.getLogs(Object.assign(Object.assign({}, options), {
                      topics: topics,
                      address: this.getAddress()
                    }));

                  case 2:
                    logs = _context4.sent;
                    return _context4.abrupt("return", logs.map(function (log) {
                      return _this4.prepareEventLog(log);
                    }));

                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));
        },
        subscribeLogs: function subscribeLogs() {
          return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            var _this5 = this;

            var result, subject;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    result = new rxjs_1.Subject();
                    _context5.next = 3;
                    return this.query.subscription.create(query_1.queryModules.Subscription.Types.Logs, {
                      topics: topics,
                      address: this.address
                    });

                  case 3:
                    subject = _context5.sent;
                    subject.pipe(operators_1.map(function (log) {
                      return _this5.prepareEventLog(log);
                    })).subscribe(result);
                    return _context5.abrupt("return", result);

                  case 6:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));
        }
      };
    }
  }, {
    key: "prepareEventLog",
    value: function prepareEventLog(log) {
      var event = null;
      var payload = {};
      var topics = log.topics;
      var signature;
      var _topics = topics;

      var _topics2 = _toArray(_topics);

      signature = _topics2[0];
      topics = _topics2.slice(1);
      var mappedEvent = this.eventsMap.signatures.get(signature);

      if (mappedEvent) {
        var name = mappedEvent.name,
            _mappedEvent$inputs = mappedEvent.inputs,
            indexed = _mappedEvent$inputs.indexed,
            nonIndexed = _mappedEvent$inputs.nonIndexed;
        var data = log.data;
        event = name;

        if (indexed.length) {
          payload = utils_1.abi.decode(indexed, utils_1.concatHex.apply(utils_1, _toConsumableArray(topics)), false);
        }

        if (nonIndexed.length) {
          payload = Object.assign(Object.assign({}, payload), utils_1.abi.decode(nonIndexed, data, false));
        }
      }

      return Object.assign(Object.assign({}, log), {
        event: event,
        payload: payload
      });
    }
  }, {
    key: "address",
    get: function get() {
      return this.currentAddress;
    },
    set: function set(address) {
      this.currentAddress = utils_1.toChecksumAddress(address);
    }
  }], [{
    key: "buildSignature",
    value: function buildSignature(methodName, params) {
      return utils_1.keccak256("".concat(methodName, "(").concat(params.map(function (_ref3) {
        var type = _ref3.type;
        return type;
      }).join(','), ")"));
    }
  }]);

  return Contract;
}(query_1.WithQuery);

exports.Contract = Contract;